import { addTranslation } from '../../_helpers/Translate';

addTranslation({
  ru: {
    header_login: 'Войти',
    header_profile: 'Профиль',
    header_changePass: 'Смена пароля',
    header_logout: 'Выйти',
    header_darkMode: 'Ночной режим'
  },
  kk: {
    header_login: 'Кіру',
    header_profile: 'Профиль',
    header_changePass: 'Құпия сөзді өзгерту',
    header_logout: 'Шығу',
    header_darkMode: 'Түнгі режим'
  }
});
